import gql from 'graphql-tag'

export const ProjectsFetchQuery = gql`
  query ProjectsFetchQuery {
    projects {
      list {
        id
        name
        created_at
      }
    }
  }
`

export const WeldersFetchQuery = gql`
  query WeldersFetchQuery($filters: PeopleFilterInput) {
    people(filters: $filters) {
      list {
        id 
        name
      }
    }
  }
`

export const ProjectsFetchQueryWithInspectionsDict = gql`
  query ProjectsFetchQuery {
    projects {
      list {
        id
        name
        welding_length
        welding_complete
        inspections_length
        created_at
        extra_columns
      }
    }
    inspection_category_types {
      id
      name
    }
    companies {
      list {
        id
        name
      }
    }
  }
`

export const ElementsFetchQuery = gql`
  query ElementsFetchQuery($parent_id: Int!, $descendants: Boolean = true) {
    elements(parent_id: $parent_id, descendants: $descendants) {
      list{
        id
        name
        depth
        welding_length
        welding_complete
        inspections_length
        created_at
      }
    }
  }
`

export const ProjectDefectivenessQuery = gql`
  query ProjectDefectivenessQuery($project_id: ID!, $project_ids: [ID], $with_children: Boolean, $date_from: String, $date_to: String, $date_type: String, $executor_company_id: ID) {
    project_defectiveness(project_id: $project_id, project_ids: $project_ids, with_children: $with_children, date_from: $date_from, date_to: $date_to, date_type: $date_type, executor_company_id: $executor_company_id) {
      total_length
      total_complete
      total_failed
      inspection_categories {
        inspection_category_type_name
        total_complete
        total_failed
        inspection_category_type_id
        failed_percentage
      }
    }
  }
`

export const ProjectDefectivenessDetailsQuery = gql`
  query ProjectDefectivenessDetailsQuery($project_id: ID!, $project_ids: [ID], $with_children: Boolean, $date_from: String, $date_to: String, $selected_columns: [String!], $date_type: String, $show_all: Boolean, $executor_company_id: ID) {
    project_defectiveness_details(project_id: $project_id, project_ids: $project_ids, with_children: $with_children, date_from: $date_from, date_to: $date_to, selected_columns: $selected_columns, date_type: $date_type, show_all: $show_all, executor_company_id: $executor_company_id)
  }
`

export const WeldingProgressHistoryFetchQuery = gql`
  query WeldingProgressHistoryFetchQuery($project_id: ID!, $date_from: String!, $date_to: String!) {
    welding_progress_history(project_id: $project_id, date_from: $date_from, date_to: $date_to) {
      labels
      data
      welding_end_date
      planned_start_date
      planned_end_date
    }
  }
`

export const WelderDefectivenessQuery = gql`
  query WelderDefectivenessQuery($project_id: ID, $project_ids: [ID], $with_children: Boolean,
   $welder_ids: [ID], $date_from: String, $date_to: String, $date_type: String) {
    welder_defectiveness(project_id: $project_id, project_ids: $project_ids, with_children: $with_children,
     welder_ids: $welder_ids, date_from: $date_from, date_to: $date_to, date_type: $date_type) {
      person_id
      welder_name
      welding_length
      total_complete
      total_failed
      failed_percentage
      inspection_categories {
        inspection_category_type_id
        inspection_category_type_name
        total_complete
        total_failed
        failed_percentage
      }
    }
  }
`

export const WelderWeldingHistoryFetchQuery = gql`
  query WelderWeldingHistoryFetchQuery($pageSize: Int = 10, $page: Int = 1, $project_id: ID, $project_ids: [ID],
   $welder_id: ID, $date_from: String, $date_to: String) {
    welder_welding_history(page: $page, size: $pageSize, project_id: $project_id, project_ids: $project_ids,
     welder_id: $welder_id, date_from: $date_from, date_to: $date_to) {
      list {
        welder {
          id
          name
        }
        welding_length
        inspections
      }
      metadata {
        total_count
        total_pages
        prev_page
        current_page
        next_page
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Report/query.js